import React from 'react';
import {bindActionCreators} from 'redux';
import {connect} from 'react-redux';

import {fetchDataIfReady, setAlert} from '../modules/fetch.action.js';
import {handleAutoResize, handleChange, handleSubChange, areFieldsNotEmpty, areFieldsValid, sanitizePayload} from '../modules/functions.js';
import Metadata from './Metadata.js';
import i18n_texts from '../i18n.js';

const e = React.createElement;


function Profile(props) {
  React.Component.constructor.call(this);

  var new_state = {};
  var update_data = {};
  if(props.apiData["profile"] && props.apiData["profile"]["data"] && props.apiData["profile"]["data"][0]) update_data = props.apiData["profile"]["data"][0];
  for(var i = 0; i < props.fields.length; i++) {
    var f = props.fields[i];
    new_state[f.dbcol] = update_data[f.dbcol];
  }
  this.state = new_state;

  for(var i = 0; i < props.fields.length; i++) {
    if(props.fields[i].type === "textarea") {
      this["fieldRef"+i] = React.createRef();
    }
  }
}
Profile.prototype = Object.create(React.Component.prototype);


Profile.prototype.componentDidMount = function() {
  for(var i = 0; i < this.props.fields.length; i++) {
    if(this.props.fields[i].type === "textarea" && this["fieldRef"+i].current) {
      handleAutoResize(this, this["fieldRef"+i].current, this.props.fields[i].dbcol);
    }
  }
}

// todo: cWRP nog toevoegen denk ik, dit fixt wss ook de bug bij opnieuw inloggen dat update data niet getoond wordt.

Profile.prototype.componentDidUpdate = function() {
  for(var i = 0; i < this.props.fields.length; i++) {
    if(this.props.fields[i].type === "textarea" && this["fieldRef"+i].current) {
      handleAutoResize(this, this["fieldRef"+i].current, this.props.fields[i].dbcol);
    }
  }
}

Profile.prototype.render = function() {
  var form_fields = [];
  form_fields = this.formatFields(this.props.fields, form_fields, 0, false);
  form_fields[form_fields.length] = e('div', {key:"submit"}, e('input', {type:"submit", value:i18n_texts["core_settings_save"][this.props.lang], disabled:this.props.is_fetching}));

  return e('div', null, [e('strong', {key:"settings-title"}, i18n_texts["core_profile_title"][this.props.lang]), e('div', {key:"settings-form", className:"card settings"}, e('form', {onSubmit:function(e) {this.handleCreate(e)}.bind(this)}, form_fields))]);
}

Profile.prototype.formatFields = function(fields, form_fields, c_i) {
  for(var i = 0; i < fields.length; i++) {
    var f = fields[i];
    var field_value = (this.state[f.dbcol]) ? this.state[f.dbcol] : "";
    var field_handleChange = handleChange.bind(null, this, f.dbcol);
    if(f.type === "textarea") {
      form_fields[i] = e('div', {key:i}, e('textarea', {
        rows:f.rows ? f.rows : 1,
        placeholder:f.placeholder,
        value:this.state[f.dbcol],
        onChange:handleChange.bind(null, this, f.dbcol),
        maxLength:f.maxLength,
        autoFocus:i === 0 ? true : false,
        ref:this["fieldRef"+i],
        style:{height:this.state[f.dbcol+"_height"]},
        onKeyDown:!f.rows ? function(e) {e.key === "Enter" && this.handleCreate(e)}.bind(this) : null
      }));
    } else if(f.type === "display") {
      form_fields[c_i+i] = e('div', {key:c_i+i}, field_value);
    } else if(f.type === "text") {
      form_fields[c_i+i] = e('div', {key:c_i+i}, e('input', {
        type:"text",
        placeholder:f.placeholder,
        value:field_value,
        onChange:field_handleChange,
        maxLength:f.maxLength,
      }));
    } else if(f.type === "date") {
      form_fields[c_i+i] = e('div', {key:c_i+i}, e('input', {
        type:"date",
        placeholder:f.placeholder,
        value:field_value,
        onChange:field_handleChange,
        maxLength:"10",
      }));
    } else if(f.type === "color") {
      form_fields[c_i+i] = e('div', {key:c_i+i}, [e('input', {
        key:"c"+c_i+i,
        type:"color",
        placeholder:f.placeholder,
        value:field_value.startsWith("#") ? field_value : "#"+field_value,
        onChange:field_handleChange,
      }), e('label', {key:"l"+c_i+i}, f.placeholder)]);
    } else if(f.type === "select") {
      var select_fields = [];
      for(var so_i = 0; so_i < f.options.length; so_i++) {
        var o = f.options[so_i];
        select_fields[so_i] = e('option', {key:"so"+so_i, value:o.value}, o.label);
      }
      form_fields[c_i+i] = e('select', {key:c_i+i, name:f.dbcol, onChange:field_handleChange, value:field_value}, select_fields);
    } else if(f.type === "contacts") {
      // todo: i18n
      var contact_fields = {};
      if(field_value !== "" && typeof field_value === "string") {
        contact_fields = JSON.parse(field_value);
      } else {
        contact_fields = field_value;
      }
      form_fields[c_i+i] = e('div', {key:c_i+i, style:{marginTop:"2em"}}, [e('div', {key:"t"+c_i+i, style:{marginBottom:"7px", fontSize:"85%"}}, f.placeholder),
      e('input', {
        key:"it"+c_i+i,
        type:"text",
        placeholder:"Telephone Number",
        value:contact_fields.telephone ? contact_fields.telephone : "",
        onChange:handleSubChange.bind(null, this, "telephone", f.dbcol, field_value !== "" ? contact_fields : {}),
        maxLength:25,
      }),
      e('input', {
        key:"ie"+c_i+i,
        type:"text",
        placeholder:"Email address",
        value:contact_fields.email ? contact_fields.email : "",
        onChange:handleSubChange.bind(null, this, "email", f.dbcol, field_value !== "" ? contact_fields : {}),
        maxLength:25,
      }),
      e('input', {
        key:"is"+c_i+i,
        type:"text",
        placeholder:"Street + Housenumber",
        value:contact_fields.street ? contact_fields.street : "",
        onChange:handleSubChange.bind(null, this, "street", f.dbcol, field_value !== "" ? contact_fields : {}),
        maxLength:25,
      }),
      e('input', {
        key:"ip"+c_i+i,
        type:"text",
        placeholder:"Postal code + City",
        value:contact_fields.postal ? contact_fields.postal : "",
        onChange:handleSubChange.bind(null, this, "postal", f.dbcol, field_value !== "" ? contact_fields : {}),
        maxLength:25,
      }),
      e('input', {
        key:"ic"+c_i+i,
        type:"text",
        placeholder:"Country",
        value:contact_fields.country ? contact_fields.country : "",
        onChange:handleSubChange.bind(null, this, "country", f.dbcol, field_value !== "" ? contact_fields : {}),
        maxLength:25,
      })]);
    } else if(f.type === "multi") {
      form_fields[c_i+i] = e('div', {key:c_i+i, style:{marginTop:"14px"}}, e(Metadata, {metadata_list:this.props.metadata_list, item_metadata:this.state[f.dbcol], item_metadata_sn:f.dbcol, updateMetadata:handleChange.bind(null, this), multi:"Links"}));
    }
  }
  return form_fields;
}

Profile.prototype.handleCreate = function(e) {
  e.preventDefault();
  var payload = {}, state_reset = {};
  for(var i = 0; i < this.props.fields.length; i++) {
    var f = this.props.fields[i];
    if(f.type !== "img" && f.type !== "labels" && f.type !== "metadata") {
      payload[f.dbcol] = this.state[f.dbcol] ? this.state[f.dbcol] : "";
      if(f.type === "textarea") state_reset[f.dbcol+"_height"] = "";
      if(f.type === "select" && payload[f.dbcol] === "") payload[f.dbcol] = f.defaultValue;
    } else if(f.type === "multi") {
      if(this.props.update_data) { // not used i think
        var init_splitted = this.state[f.dbcol+"_initial"].split(";;");
        var new_splitted = this.state[f.dbcol].split(";;");
        var nw_labels = new_splitted.filter(function(_metadata_json) {
          return init_splitted.indexOf(_metadata_json) === -1;
        }).join(';;');
        var rm_labels = init_splitted.filter(function(_metadata_json) {
          return new_splitted.indexOf(_metadata_json) === -1;
        }).join(';;');
        payload["nw_"+f.dbcol] = nw_labels;
        payload["rm_"+f.dbcol] = rm_labels;
      } else {
        payload[f.dbcol] = this.state[f.dbcol] ? this.state[f.dbcol] : "";
      }
      //state_reset[f.dbcol+"_initial"] = "";
      //state_reset[f.dbcol] = "";
    }
  }

  if(!this.props.required_fields || (this.props.required_fields && areFieldsNotEmpty(this.props.required_fields, payload, this.props.setAlert))) {
    if(!this.props.validate_fields || (this.props.validate_fields && areFieldsValid(this.props.validate_fields, payload, this.props.setAlert))) {
      if(this.props.is_fetching === false || this.props.is_fetching === null) {
        if(this.props.validate_fields) {
          payload = sanitizePayload(this.props.validate_fields, payload);
        }
        payload.session_token = this.props.session_token;
        var success_alert = (typeof this.props.success_alert !== 'undefined') ? success_alert : true;
        if(payload.username) {
          payload.username = payload.username.replace(/[^a-zA-Z0-9_.]/gi, '');
        }
        this.props.fetchDataIfReady(this.props.config.api_token, this.props.api_block, this.props.api_method, this.props.config.api_url+this.props.api_endpoint, JSON.stringify(payload), null, true, false, success_alert, "profile", false, null, this.props.api_block_clear);
        this.setState(Object.assign({}, payload, state_reset)); // sets the state to the validated/cleaned payload, exactly as it was sent to the API.
      }
    }
  }
}


function mapStateToProps(state, ownProps) {
  var session_token = null, is_fetching = null;
  if(state.apiData["login"] !== undefined && (state.apiData["login"]["data"]["token"] !== undefined || state.apiData["login"]["data"]["token"] === null)) {
    session_token = state.apiData["login"]["data"]["token"];
  }
  if(state.apiData[ownProps.api_block] !== undefined && state.apiData[ownProps.api_block].isFetching !== undefined) {
    is_fetching = state.apiData[ownProps.api_block].isFetching;
  }

  return {
    session_token: session_token,
    is_fetching: is_fetching,
    apiData: state.apiData,
  }
}

function mapDispatchToProps(dispatch){
  return bindActionCreators({
    fetchDataIfReady,
    setAlert,
  }, dispatch);
}

export default connect(mapStateToProps, mapDispatchToProps)(Profile)



//////////////////
// WEBPACK FOOTER
// ../_Skelet/src/components/Profile.js
// module id = 193
// module chunks = 0